<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <span></span>
</template>
<script lang="js">
export default {
  name: 'highlights-badge',
  props: [],
};
</script>
